/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalTranscoder
 */
export interface ExternalTranscoder {
    /**
     * 
     * @type {number}
     * @memberof ExternalTranscoder
     */
    id: number;
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof ExternalTranscoder
     */
    pathMappings: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoder
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoder
     */
    type?: ExternalTranscoderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalTranscoder
     */
    address: string;
}

/**
* @export
* @enum {string}
*/
export enum ExternalTranscoderTypeEnum {
    Transkoder = 'transkoder',
    Vantage = 'vantage'
}

export function ExternalTranscoderFromJSON(json: any): ExternalTranscoder {
    return ExternalTranscoderFromJSONTyped(json, false);
}

export function ExternalTranscoderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalTranscoder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pathMappings': json['path_mappings'],
        'name': json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'address': json['address'],
    };
}

export function ExternalTranscoderToJSON(value?: ExternalTranscoder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'path_mappings': value.pathMappings,
        'name': value.name,
        'type': value.type,
        'address': value.address,
    };
}


